<div class="text-end mt-2">
  <div
    class="btn btn-primary"
    (click)="openModal(createModal, {
      localConnection: '',
      host: '',
      hasTelco: false,
      mandant: '',
      enabled: false
  })"
    i18n="@@new-mandant"
  >Neuer Mandant</div>
</div>
<!-- TODO: Translated labels-->
<lib-rag-datasupply-table
  [service]="frontendService"
  [columns]="[
    {fieldName: 'short', label: 'Mandant'}
  ]"
  (onSelect)="this.openModal(editModal, $event)"
  [translatedLabels]="this.translatedLabels"
></lib-rag-datasupply-table>

<ng-template #createModal>
  <div
    class="modal-body"
    *ngIf="this.modalRef?.content?.data"
  >
    <!-- TODO: Translated labels-->
    <rag-form
      [data]="this.modalRef.content.data"
      [translateTexts]="this.translateTexts"
      [formFields]="[
        {fieldName: 'short', label: 'Mandant-Short', type: 'text', required: true},
        {fieldName: 'email', label: 'E-Mail', type: 'text', required: true}
      ]"
      [translatedLabels]="this.translatedLabelsForm"
      [type]="'create'"
      (submit)="this.createMandant($event)"
    ></rag-form>
  </div>
</ng-template>

<ng-template #editModal>
  <div
    class="modal-body"
    *ngIf="this.modalRef?.content?.data"
  >
    <div class="modal-header">
      <div class="modal-title">
        <h3>{{this.modalRef.content.data.short}}</h3>
      </div>
    </div>

    <app-mandant-license
      [licenses]="this.shortToLicensesMap.get(this.modalRef.content.data.short)"
      [short]="this.modalRef.content.data.short"
      (licenseChanges)="this.loadMandants()"
    ></app-mandant-license>
  </div>
</ng-template>